import { useConfiguration } from 'common/hooks/useConfiguration';
import { ReactElement } from 'react';
import { Route } from 'react-router';
import { SwitchWithNotFound } from '../containers/SwitchWithNotFound';
import { LockedView } from '../views/auth/Locked.view';
import { NotFoundView } from '../views/errors/NotFound.view';
import { AdminView } from '../views/home/admin/admin.view';
import { DatasetsView } from '../views/home/Datasets.view';
import { IntegrationsView } from '../views/home/Integrations.view';
import { TeamView } from '../views/home/Team.view';
import { CloudCostsView } from '../views/home/user/CloudCosts.view';
import { UserDetailsAccountView } from '../views/home/user/UserDetailsAccount.view';
import { WorkspacesView } from '../views/home/Workspaces.view';
import { AnnotationsRoute } from './annotations.route';
import { AttachmentsRoute } from './attachments.route';
import { Home } from './config/Home';
import { FreeAccessRoute } from './freeAccess.route';
import { InferencesRoute } from './inferences/inferences.route';
import { ProjectsRoute } from './projects/projects.route';
import { TrainingsRoute } from './trainings/trainings.route';

export const HomeRoute = (): ReactElement => {
  const config = useConfiguration();
  return (
    <SwitchWithNotFound notFound={<NotFoundView />}>
      <Route path={Home.Projects.Path}>
        <ProjectsRoute />
      </Route>
      <Route path={Home.Datasets.Path}>
        <DatasetsView />
      </Route>
      <Route path={Home.Annotations.Path}>
        <AnnotationsRoute />
      </Route>
      <Route path={Home.FreeAccess.Path}>
        <FreeAccessRoute />
      </Route>
      <Route path={Home.Admin.Path}>
        <AdminView />
      </Route>
      <Route path={Home.User.Account.Path}>
        <UserDetailsAccountView />
      </Route>
      {!config.appConfig.runLocally && (
        <Route path={Home.User.CloudCosts.Path}>
          <CloudCostsView />
        </Route>
      )}
      <Route path={Home.Locked.Path}>
        <LockedView />
      </Route>
      <Route path={Home.Integrations.Path}>
        <IntegrationsView />
      </Route>
      <Route path={Home.Team.Path}>
        <TeamView />
      </Route>
      <Route path={Home.Workspaces.Path}>
        <WorkspacesView />
      </Route>
      <Route path={Home.Attachments.Path}>
        <AttachmentsRoute />
      </Route>
      <Route path={Home.Trainings.Path}>
        <TrainingsRoute />
      </Route>
      <Route path={Home.Inferences.Path}>
        <InferencesRoute />
      </Route>
    </SwitchWithNotFound>
  );
};
